import { HighlightSerif, Reveal } from '@dialogueconsulting/sked-ui'
import { HappySquirrel } from 'Icons'

import PoweredBySked from './Common/PoweredBySked'

const EmptyUpcomingPosts: React.FC = () => {
  return (
    <div className="mx-auto mb-[120px] mt-[70px] grid place-items-center max-[767px]:my-[14px] [&>svg]:mb-28 [&>svg]:mt-10 [&>svg]:w-[214px] max-[767px]:[&>svg]:mb-[65px] max-[767px]:[&>svg]:mt-[60px]">
      {/* SKE-4300 — the empty state is one of the sanctioned Tiempos moments,
          and at 32px this heading is genuinely display size (the highlight
          carries a 1.06em bump, so it is wrong on UI-chrome type). The "!"
          sits INSIDE the italic: punctuation trailing a styled phrase takes
          that phrase's style, and it must not detach from it.
          <Reveal> gives the state a single quiet entrance and renders the
          final state outright under prefers-reduced-motion. */}
      <Reveal className="max-w-[360px] rounded-[10px] bg-[#f0f8e7] px-[30px] py-5 text-center">
        {/* Gotham Black, not medium: the canon pairing is a HEAVY Gotham
            headline carrying one lighter serif accent. At weight 500 the
            headline was lighter than its own 600-weight, 1.06em accent, so the
            highlight outshouted the sentence it was meant to inflect. */}
        <h2 className="font-gotham text-[32px] font-black">
          Time to <HighlightSerif>zen out!</HighlightSerif>
        </h2>
        <span className="text-sm">
          No upcoming posts or posts awaiting approval.
        </span>
      </Reveal>
      <HappySquirrel data-testid="squirrel_logo" />
      <PoweredBySked />
    </div>
  )
}

export default EmptyUpcomingPosts
